// extracted by mini-css-extract-plugin
module.exports = {"select":"select__1r-n6","menu":"menu__v_Hn2","label":"label__3RNab","open":"open__1LCh7","placeholder":"placeholder__NbWyY"};